import styled from 'styled-components';
import FacebookLogo from '/public/svg/social/fb.svg';
import InstagramLogo from '/public/svg/social/ig.svg';
import LinkedInLogo from '/public/svg/social/linked.svg';

const SocialContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 20px;
    margin-top: 10px;
    height: 42px;

    svg {
        height: 20px;
        width: 20px;
        path, & > * {
          fill: #6e6e73 !important;
        }
    }
`;

export const PostSocialLinks = ({ socialLinks }) => {
    return <SocialContainer>
        <a
            href={socialLinks.facebook}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
        >
            <FacebookLogo />
        </a>
        <a
            href={socialLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
        >
            <InstagramLogo />
        </a>
        <a
            href={socialLinks.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
        >
            <LinkedInLogo />
        </a>
    </SocialContainer>;
};
